<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NbPxkm/tc-custom/9781455572274.jpg?1737166184407" alt="This image is the cover for the book Rebel of Copper Creek, Copper Creek Cowboys"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rebel of Copper Creek, Copper Creek Cowboys
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A Montana widow learns to open her heart to a love as big as the sky in this “wonderfully touching” contemporary Western romance (</b><i><b>Fresh Fiction</b></i><b>).</b></p><p>The last thing Juliet Grayson needs is a new man in her life. Between caring for her two young sons and maintaining her late husband's ranch, her hands are more than full. Then she meets Griff Warren. With his quiet strength and his easy way with her boys, she's tempted to trust him. But if there's anything she's learned, it's that love only leads to heartbreak.<br/><br/>Former Marine Griff Warren never thought he'd settle down. Rebellious and proud, he's always been on his own…until he lost the father he never knew he had, leaving him with land that is his legacy and brothers to share the load. </p><p>Griff doesn't need more than that. But Juliet touches something deep inside him. Now if only he can convince her to take a second chance at true love.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R.C. Ryan
      </h2>
      
      <p class="authorDescription body article"><I>New York Times</I> bestselling author <B>R.C. Ryan</B> has written more than ninety novels, both contemporary and historical.  Quite an accomplishment for someone who, after her fifth child started school, gave herself the gift of an hour a day to follow her dream to become a writer. <br><br> In a career spanning more than twenty years, Ms. Ryan has given dozens of radio, television, and print interviews across the country and Canada, and has been quoted in such diverse publications as the <I>Wall Street Journal</I> and <I>Cosmopolitan</I>.  She has also appeared on <I>CNN News</I> and <I>Good Morning America</I>. <br><br> R.C. Ryan is a pseudonym of <I>New York Times</I> bestselling author Ruth Ryan Langan.<br><br> You can learn more about R. C. Ryan and her alter ego Ruth Ryan Langan at:<br> RyanLangan.com<br> Twitter, @RuthRyanLangan<br> Facebook.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grand Central Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c913cb1c